// extracted by mini-css-extract-plugin
export var dropdown = "_jr-1";
export var hidden = "_jr-0";